import React, { useState, } from 'react';
import fileDownload from 'js-file-download';
import { TextEncoder, } from 'text-encoding';
import { unparse as unparseCsv, } from 'papaparse';
import { orderBy, uniq, isFunction } from 'lodash';
import classnames from 'classnames';
import { Button, } from 'reactstrap';
import { toast, } from 'react-toastify';

const { keys } = Object;

export default function ExportButton ({ label = 'エクスポート', fileName, rows, onFinish = _ => _, headersOrder, ...extraProps }) {
  const [isExporting, setIsExporting] = useState(false);

  const onClickExport = async () => {
    setIsExporting(true);
    try {
      const encoder = new TextEncoder('Shift_JIS', { NONSTANDARD_allowLegacyEncoding: true });
      const _rows = isFunction(rows) ? (await rows()) : rows;
      const headers = (_ => headersOrder ? orderBy(_, ...headersOrder) : _)(uniq(_rows.flatMap(_ => keys(_))));
      const fileContent = encoder.encode(unparseCsv({ fields: headers, data: _rows.map(_ => headers.map(h => _[h])) }));
      fileDownload(fileContent, fileName);
      onFinish(_rows);
    } catch(e) {
      console.log(e);
      toast.error(`失敗しました。${e.message}`);
    }
    setIsExporting(false);
  };

  return (
    <Button color="secondary" onClick={onClickExport} disabled={isExporting} {...extraProps}>
      <span className={classnames('fas mr-1', { 'fa-spin fa-spinner': isExporting, 'fa-download': !isExporting })} />
      {label}
    </Button>
  );
};
